import { SUPPORT } from '../utils/constants'

export default {
  data: () => ({
    baseCrudl: {
      COOLRUNNER_ONLY: true,
      C: SUPPORT.val,
      R: SUPPORT.val,
      U: SUPPORT.val,
      D: SUPPORT.val,
      L: SUPPORT.val,
    },
    crudl: {
      COOLRUNNER_ONLY: true,
      C: SUPPORT.val,
      R: SUPPORT.val,
      U: SUPPORT.val,
      D: SUPPORT.val,
      L: SUPPORT.val,
    },
  }),
  computed: {
    computedCrudl: function (params) {
      return { ...this.baseCrudl, ...this.crudl }
    },
  },
  methods: {
    canCreate () {
      const hasPermission = this.$getUser().role >= this.computedCrudl.C
      if (!hasPermission) { this.$toast(this.$t('not_enough_permissions', { action: this.$t('to_create') }), { color: 'red' }) }

      return (hasPermission)
    },
    canRead () {
      const hasPermission = this.$getUser().role >= this.computedCrudl.R
      if (!hasPermission) { this.$toast(this.$t('not_enough_permissions', { action: this.$t('to_read') }), { color: 'red' }) }

      return (hasPermission)
    },
    canUpdate () {
      const hasPermission = this.$getUser().role >= this.computedCrudl.U
      if (!hasPermission) { this.$toast(this.$t('not_enough_permissions', { action: this.$t('to_update') }), { color: 'red' }) }

      return (hasPermission)
    },
    canDelete () {
      const hasPermission = this.$getUser().role >= this.computedCrudl.D
      if (!hasPermission) { this.$toast(this.$t('not_enough_permissions', { action: this.$t('to_delete') }), { color: 'red' }) }

      return (hasPermission)
    },
    canList () {
      const hasPermission = this.$getUser().role >= this.computedCrudl.L
      if (!hasPermission) { this.$toast(this.$t('not_enough_permissions', { action: this.$t('see_list') }), { color: 'red' }) }

      return (hasPermission)
    },
  },
}
